// @react/hooks/useSignature.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { signatureStore } from '@core/stores';

/**
 * React hook for Signature operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useSignature } from '@react/hooks';
 *
 * const SignatureList = observer(() => {
 *   const store = useSignature();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useSignature() {
  return signatureStore;
}
